var _g, _rect, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocialGoogleSquare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#social_google_square_svg__clip0_12971_3256)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#social_google_square_svg__filter0_bd_12971_3256)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "social_google_square_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10
  })), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10,
    fill: "url(#social_google_square_svg__paint0_radial_12971_3256)",
    fillOpacity: 0.7,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 10,
    stroke: "#fff",
    strokeWidth: 32.941,
    shapeRendering: "crispEdges",
    mask: "url(#social_google_square_svg__a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.5 32.289c0-1.069-.089-1.849-.28-2.658H32.765v4.825h7.31c-.147 1.198-.943 3.004-2.711 4.217l-.025.162 3.938 2.99.273.026c2.505-2.268 3.95-5.604 3.95-9.562z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.764 45c3.582 0 6.589-1.156 8.785-3.149l-4.186-3.178c-1.12.766-2.624 1.3-4.599 1.3a7.97 7.97 0 01-7.546-5.402l-.156.013-4.094 3.106-.054.146C23.095 42.082 27.576 45 32.764 45z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.219 34.571A7.857 7.857 0 0124.777 32c0-.896.162-1.762.427-2.571l-.007-.172L21.05 26.1l-.136.063A12.802 12.802 0 0019.5 32a12.8 12.8 0 001.415 5.835l4.304-3.264z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.764 24.027c2.491 0 4.172 1.054 5.13 1.935l3.744-3.582c-2.3-2.094-5.292-3.38-8.873-3.38-5.189 0-9.67 2.918-11.85 7.164l4.288 3.265c1.076-3.135 4.054-5.402 7.561-5.402z",
    fill: "#EB4335"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.25,
    width: 63.5,
    height: 63.5,
    rx: 9.75,
    stroke: "#000",
    strokeOpacity: 0.2,
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "social_google_square_svg__paint0_radial_12971_3256",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 32 -32 0 32 32)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "social_google_square_svg__clip0_12971_3256"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 10,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "social_google_square_svg__filter0_bd_12971_3256",
    x: -325.294,
    y: -325.294,
    width: 714.588,
    height: 714.588,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "BackgroundImageFix",
    stdDeviation: 162.647
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_12971_3256"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 49.412
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 39.118
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0867708 0 0 0 0 0.115317 0 0 0 0 0.141667 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_backgroundBlur_12971_3256",
    result: "effect2_dropShadow_12971_3256"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_12971_3256",
    result: "shape"
  })))));
}

export default SvgSocialGoogleSquare;